import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from '../locales/en/translation.json';
import translationES from '../locales/es/translation.json';
import { userService } from './UserService';

const resources = {
  en: { translation: translationEN },
  es: { translation: translationES }
};

class TranslationService {
  constructor() {
    this._i18n = i18n;
    this._initialized = false;
    this._currentLanguage = 'en';
  }

  async initialize() {
    if (this._initialized) return;

    await this._i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources,
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
          escapeValue: false,
        },
        detection: {
          order: ['localStorage', 'navigator'],
          lookupLocalStorage: 'i18nextLng',
          caches: ['localStorage'],
        },
      });

    this._initialized = true;
    this._currentLanguage = this._i18n.language;

    // Subscribe to user service to detect language changes from Firestore
    userService.subscribe((user) => {
      if (user && user.appInterfaceLanguageLocale) {
        this.changeLanguage(user.appInterfaceLanguageLocale);
      }
    });
    
    // Initial check
    const currentUser = userService.currentUser;
    if (currentUser && currentUser.appInterfaceLanguageLocale) {
        this.changeLanguage(currentUser.appInterfaceLanguageLocale);
    }
  }

  changeLanguage(locale) {
    if (locale) {
        // Basic normalization: 'es-ES' -> 'es'
        const langCode = locale.split('-')[0];
        
        // Only change if supported and different
        if ((resources[langCode] || resources[locale]) && langCode !== this._currentLanguage) {
            this._i18n.changeLanguage(langCode);
            this._currentLanguage = langCode;
        }
    }
  }

  getCurrentLanguage() {
    return this._currentLanguage;
  }

  get i18n() {
    return this._i18n;
  }
}

export const translationService = new TranslationService();



